<template>
	<div v-if="!isSalesHeader">
		<template v-if="urlPath === '/mamafit'">
			<AtomButton
				class="lg:hidden"
				size="sm"
				:variant="ButtonVariant.Brand"
				icon-left="fa-heart"
				text="Informatiepakket aanvragen"
				:to="{ title: 'Informatiepakket aanvragen', url: '#aanmelden' }"
				@click="
					() => {
						trackButtonClick(
							'OrganismHeaderBar_CTA_ZFT_Mobile',
						);
					}
				"
			/>
			<AtomButton
				class="hidden lg:flex"
				size="md"
				:variant="ButtonVariant.Brand"
				icon-left="fa-heart"
				text="Informatiepakket aanvragen"
				:to="{ title: 'Informatiepakket aanvragen', url: '#aanmelden' }"
				@click="
					() => {
						trackButtonClick(
							'OrganismHeaderBar_CTA_ZFT_Desktop',
						);
					}
				"
			/>
		</template>
		<template v-else-if="urlPath === '/private-group-training'">
			<AtomButton
				class="lg:hidden"
				size="sm"
				:variant="ButtonVariant.Green"
				icon-left="fa-bolt"
				text="Informatie aanvragen"
				:to="{ title: 'Private Group Training informatie aanvragen', url: '#aanmelden' }"
				@click="
					() => {
						trackButtonClick(
							'OrganismHeaderBar_CTA_PGT_Mobile',
						);
					}
				"
			/>
			<AtomButton
				class="hidden lg:flex"
				size="md"
				:variant="ButtonVariant.Green"
				icon-left="fa-bolt"
				text="Informatie aanvragen"
				:to="{ title: 'Private Group Training informatie aanvragen', url: '#aanmelden' }"
				@click="
					() => {
						trackButtonClick(
							'OrganismHeaderBar_CTA_PGT_Desktop',
						);
					}
				"
			/>
		</template>
		<template v-else-if="urlPath === '/personal-training'">
			<AtomButton
				class="lg:hidden"
				size="sm"
				:variant="ButtonVariant.Green"
				icon-left="fa-bolt"
				text="Informatie aanvragen"
				:to="{ title: 'Personal Training informatie aanvragen', url: '#aanmelden' }"
				@click="
					() => {
						trackButtonClick(
							'OrganismHeaderBar_CTA_PT_Mobile',
						);
					}
				"
			/>
			<AtomButton
				class="hidden lg:flex"
				size="md"
				:variant="ButtonVariant.Green"
				icon-left="fa-bolt"
				text="Informatie aanvragen"
				:to="{ title: 'Personal Training informatie aanvragen', url: '#aanmelden' }"
				@click="
					() => {
						trackButtonClick(
							'OrganismHeaderBar_CTA_PT_Desktop',
						);
					}
				"
			/>
		</template>
		<template v-else>
			<AtomButton
				class="lg:hidden"
				size="sm"
				:variant="ButtonVariant.Green"
				icon-left="fa-bolt"
				text="Gratis proefles"
				:to="{ title: 'Aanmelden voor een Small Group Training proefles', url: '/small-group-training/aanmelden-proefles' }"
				@click="
					() => {
						trackButtonClick(
							'OrganismHeaderBar_CTA_SGT_Mobile',
						);
					}
				"
			/>
			<AtomButton
				class="hidden lg:flex"
				size="md"
				:variant="ButtonVariant.Green"
				icon-left="fa-bolt"
				text="Gratis proefles"
				:to="{ title: 'Aanmelden voor een Small Group Training proefles', url: '/small-group-training/aanmelden-proefles' }"
				@click="
					() => {
						trackButtonClick(
							'OrganismHeaderBar_CTA_SGT_Desktop',
						);
					}
				"
			/>
		</template>
	</div>
</template>

<script lang="ts" setup>
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';

const { isSalesHeader } = defineProps<{
	isSalesHeader?: boolean;
}>();

const { trackButtonClick } = useEventTracking();

const router = useRouter();
const urlPath = router.currentRoute.value.path;
</script>
